import React from 'react';
import { database } from '../data/database.ts';

const Footer: React.FC = () => {

  const db = database.footer;

  const currentYear = new Date().getFullYear();

  return (
    <footer id="footer" className="footer dark-background py-4">
      <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-6 mb-4 mb-lg-0">
            <h1 className="sitename">Qori Solutions</h1>
          </div>
          <div className="col-lg-8 col-md-6 mb-4 mb-lg-0 text-right">
            <div>
              <p>{db.address}</p>
              <p><strong>Contacto Whatsapp:</strong> {db.phone}</p>
            </div>
          </div>
          <div className='col-lg-12 powered'>
            <p className='main-text'>Powered by</p>
            <img className='main-image' src="assets/images/rugitec.png" alt="Rugitec" />
          </div>
          <div className="col-lg-12">
            <ul className="list-unstyled text-white small social-list">
              {
                db.socials.map((social, index) => (
                  <li key={index}><a href={social.link} className="text-light text-decoration-none"><i className={social.icon}></i></a></li>
                ))
              }
            </ul>
          </div>
          <div className="col-lg-12 text-center qtext">
            <p className="text-white">© {currentYear} QoriSolutions. Todos los derechos reservados. Desarrollado por Yakulink.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
